export const validateUniv = (obj) => {
    let status = {isValid: true, message: ""};
    // if(obj.rank < 0){
    //     status.isValid = false;
    //     status.message = "Invalid Rank Entered";
    // }
    return status;
}